<template>
    <v-container>
        <!-- サイトシールの表示領域 -->
        <v-row class="justify-center mt-10">
        <v-col cols="auto">
            <div id="ss_img_wrapper_2021gmogs_100-50_ja_w">
            <!-- SSLサイトシールのリンク -->
            <a href="https://jp.globalsign.com/" target="_blank" rel="nofollow" style="background:#fff; width:100px; height:50px;">
                <!-- SSLサイトシールの画像 -->
                <img alt="SSL GMOグローバルサインのサイトシール" border="0" id="ss_img" :src="imageSrc">
            </a>
            </div>
        </v-col>
        <v-col cols="6" sm="4" md="3">
            <p class="text-caption white--text">本サイトでのお客様の個人情報はGMOグローバルサインのSSLにより保護しております。</p>
        </v-col>
        </v-row>
    </v-container>
</template>

<script setup>
import { ref, onMounted } from 'vue';

// 画像のソースをrefで定義
const imageSrc = ref('//seal.globalsign.com/SiteSeal/images/gs_noscript_100-50_ja.gif');

onMounted(() => {
  // 外部スクリプトのロード
    const script = document.createElement('script');
    script.src = '//seal.globalsign.com/SiteSeal/2021gmogs_100-50_ja_w.js';
    script.defer = true;
    document.body.appendChild(script);
});
</script>
